import { LayoutCheckoutTable } from "@/Layout/DefaultCheckout/LayoutCheckoutTable";
import useWindowsSize from "@/Hooks/useWindowsSize";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import { formatMX } from "@/Utils/Fomat.price";

type Props = {
  mDatos: MCheckout[];
  quantity: number;
  totales: number;
};

export const Summary = ({ mDatos, quantity, totales }: Props): JSX.Element => {
  const { width } = useWindowsSize();

  const { productsItem } = mDatos[0] ?? {};

  const productos = Array.isArray(productsItem) ? productsItem : [productsItem];

  return (
    <LayoutCheckoutTable>
      <thead>
        <tr>
          <th scope="col">Articulo</th>
          <th scope="col">Precio</th>
          <th scope="col">Cantidad</th>
          <th scope="col">TOTAL</th>
        </tr>
      </thead>
      <tbody className="text-center">
        {productos?.map((item, index) => (
          <tr key={index}>
            <td>
              <div className={width > 800 ? "d-flex" : "d-flex flex-column"}>
                <div className="flex-fill">
                  <img
                    src={item.ImageGroups[0]?.images[0]?.link}
                    alt=""
                    width={100}
                    height={100}
                  />
                </div>
                <div className="flex-fill align-content-center develop___text__summary">
                  <span>{item.Name}</span>
                </div>
              </div>
            </td>
            <td className="develop___text__summary">
              ${formatMX(item.SalesPrice)}
            </td>
            <td className="develop___text__summary">{quantity}</td>
            <td className="develop___text__summary text-center">
              ${formatMX(totales)}
            </td>
          </tr>
        ))}
      </tbody>
    </LayoutCheckoutTable>
  );
};
